import  { useEffect, useState } from "react";
import axios from "axios";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, Tooltip, Legend } from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../config.js"

ChartJS.register(Tooltip, Legend);

const EmployeWorkQualityChart = () => {
  const [chartData, setChartData] = useState(null);
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/EmployeJson`);
        

        const rawData = response.data.data.Sheet1;

        // Filter out the header and total rows
        const filteredData = rawData.filter(
          (item) => typeof item["__EMPTY"] === "number"
        );

        // Extract labels and data
        const labels = filteredData.map((item) => item["YEAR"]);
        const data = filteredData.map((item) => item["__EMPTY"]);

        setChartData({ labels, data });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const data = {
      labels: chartData.labels,
      datasets: [
        {
          label: "Work Quality",
          data: chartData.data,
          backgroundColor: [
            "#FF6384", 
            "#36A2EB", 
            "#FFCE56", 
            "#4BC0C0", 
            "#9966FF", 
            "#FF9F40", 
            "#FF6384", 
            "#36A2EB", 
            "#FFCE56", 
            "#4BC0C0", 
            "#9966FF", 
            "#FF9F40", 
          ],
          borderColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#4BC0C0",
            "#9966FF",
            "#FF9F40",
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#4BC0C0",
            "#9966FF",
            "#FF9F40",
          ],
          borderWidth: 1,
        },
      ],
    };

    const options = {};

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff",textAlign:"center" }}>
            Employee Overall Work Quality
          </Typography>
        </Box>
        <Container>
          <div
            style={{
              padding: "20px",
              width: "100%",
              height: "80%",
            }}
          >
            <Pie data={data} options={options} />
          </div>
        </Container>
      </div>
    );
  }
};

export default EmployeWorkQualityChart;

